<template>
    <content-page title="Πολιτική Απορρήτου" :subtitle="`Τελευταία ενημέρωση: ${lastUpdated}`" icon="mdi-shield-lock-outline">
        <h2>Εισαγωγή και σύνοψη</h2>
        <p>
            Η ιδιωτικότητά σας είναι σημαντική για το B.I.G. Επεξεργαζόμαστε πληροφορίες που σας αφορούν
            (εφεξής «Δεδομένα») πάντα με σεβασμό στα δικαιώματά σας και στη σχετική νομοθεσία της ΕΕ. Με την
            παρούσα πολιτική θέλουμε να σας ενημερώσουμε για τον τρόπο με τον οποίο επεξεργαζόμαστε τα
            προσωπικά σας δεδομένα και για τα δικαιώματά σας. Η πολιτική εξηγεί επίσης πώς επεξεργαζόμαστε
            Δεδομένα που έχουμε στη διάθεσή μας από οποιαδήποτε επικοινωνία, σχέση ή συναλλαγή μαζί σας, καθώς
            και για οποιονδήποτε άλλο λόγο. Προσωπικά δεδομένα είναι κάθε πληροφορία που μπορεί να συνδεθεί
            με εσάς ως φυσικό πρόσωπο, για παράδειγμα το όνομα και τα στοιχεία επικοινωνίας σας.
        </p>
        <p>Συνοπτικά, επεξεργαζόμαστε τα δεδομένα σας:</p>
        <ul>
            <li>Στον βαθμό που είναι απαραίτητο για την παροχή των υπηρεσιών μας προς εσάς.</li>
            <li>Για να επικοινωνούμε μαζί σας και να απαντάμε στις ερωτήσεις σας.</li>
            <li>Για να σας ρωτάμε για το B.I.G. και την εμπειρία σας με εμάς.</li>
            <li>Για να σας ενημερώνουμε για αλλαγές στις υπηρεσίες μας.</li>
        </ul>
        <p>
            Σύμφωνα με τη νομοθεσία για την προστασία δεδομένων έχετε διάφορα δικαιώματα. Για παράδειγμα,
            έχετε πάντα το δικαίωμα να αντιταχθείτε στην επεξεργασία για σκοπούς προώθησης (marketing).
        </p>
        <p>
            Θέλετε να μάθετε περισσότερα; Παρακάτω θα βρείτε αναλυτικά <em>πώς</em>, <em>γιατί</em> και
            <em>για πόσο χρονικό διάστημα</em> επεξεργαζόμαστε τα προσωπικά σας δεδομένα.
        </p>

        <h2>Πώς τα συλλέγουμε</h2>
        <p>Συλλέγουμε πληροφορίες με διάφορους τρόπους μέσω της ιστοσελίδας/εφαρμογής, όπως:</p>
        <ul>
            <li>Εγγραφές ομάδων και παικτών</li>
            <li>Cookies και άλλες τεχνολογίες</li>
        </ul>

        <h2>Ποια Δεδομένα συλλέγουμε</h2>
        <p>Συλλέγουμε τα ακόλουθα Δεδομένα:</p>
        <ul>
            <li>Τα προσωπικά σας στοιχεία που περιλαμβάνονται στη διαδικασία εγγραφής που μας αποστέλλετε.</li>
            <li>
                Πληροφορίες σχετικά με τη διεύθυνση IP, την ώρα πρόσβασής σας στην ιστοσελίδα, το URL, τον τύπο
                και τις ρυθμίσεις του προγράμματος περιήγησής σας, καθώς και για τις πρόσφατες επισκέψεις σας
                στην ιστοσελίδα μας και το περιεχόμενο που είδατε. Τις πληροφορίες αυτές τις συλλέγουμε μέσω
                cookies και άλλων τεχνολογιών, μόνο με τη συγκατάθεσή σας, εκτός αν είναι απαραίτητες για την
                περιήγησή σας στην ιστοσελίδα. Είναι ανώνυμες και δεν μπορούμε να σας ταυτοποιήσουμε μέσω αυτών.
            </li>
        </ul>

        <h2>Για ποιον λόγο τα επεξεργαζόμαστε</h2>
        <p>Επεξεργαζόμαστε τα Δεδομένα αυτά μόνο όταν είναι απαραίτητο για:</p>
        <ul>
            <li>
                Τη διεκπεραίωση του αιτήματός σας και τη λήψη των κατάλληλων μέτρων, ώστε να έχουμε την καλύτερη
                δυνατή σχέση μαζί σας και να βελτιώνουμε τις υπηρεσίες μας.
            </li>
            <li>Την κατανόηση του τρόπου με τον οποίο χρησιμοποιείτε την ιστοσελίδα μας, ώστε να γίνεται πιο λειτουργική και ασφαλής.</li>
        </ul>
        <p>Σε ορισμένες περιπτώσεις ενδέχεται να χρειαστεί να χρησιμοποιήσουμε τα Δεδομένα για:</p>
        <ul>
            <li>Τη συμμόρφωσή μας με τις νόμιμες υποχρεώσεις μας.</li>
        </ul>

        <h2>Για πόσο καιρό τα διατηρούμε</h2>
        <p>
            Επεξεργαζόμαστε τα Δεδομένα μόνο για όσο χρόνο είναι απαραίτητο για την εκπλήρωση των σκοπών για
            τους οποίους τα συλλέξαμε. Επανεξετάζουμε περιοδικά τα Δεδομένα που έχουμε αποθηκεύσει και τα
            διαγράφουμε όταν δεν είναι πλέον απαραίτητα για τους σκοπούς αυτούς. Συγκεκριμένα:
        </p>
        <ul>
            <li>Διατηρούμε τις πληροφορίες των αιτημάτων σας για όσο χρόνο απαιτείται για την εξέτασή τους και τη λήψη των κατάλληλων ενεργειών.</li>
            <li>
                Διατηρούμε τις πληροφορίες που συλλέγουμε μέσω cookies και αρχείων καταγραφής (logs), σύμφωνα με
                την Πολιτική Cookies και Άλλων Τεχνολογιών.
            </li>
        </ul>

        <h2>Ασφάλεια</h2>
        <p>
            Λαμβάνουμε τα κατάλληλα τεχνικά και οργανωτικά μέτρα για την ασφαλή επεξεργασία των Δεδομένων,
            ώστε να αποτρέπεται η μη εξουσιοδοτημένη πρόσβαση, τροποποίηση ή γνωστοποίησή τους.
        </p>

        <h2>Υπεύθυνος Προστασίας Δεδομένων</h2>
        <p>
            Για οποιαδήποτε ερώτηση σχετικά με την επεξεργασία των δεδομένων σας, μπορείτε να επικοινωνήσετε
            με τον Υπεύθυνο Προστασίας Δεδομένων στο
            <a href="mailto:ivalmas@backinthegame.gr">ivalmas@backinthegame.gr</a>.
        </p>

        <h2>Τα δικαιώματά σας</h2>
        <p>
            Σύμφωνα με τη νομοθεσία για την προστασία δεδομένων, έχετε μια σειρά από δικαιώματα σχετικά με την
            επεξεργασία των προσωπικών σας δεδομένων. Τα δικαιώματα αυτά ορίζονται στον Γενικό Κανονισμό
            Προστασίας Δεδομένων (ΓΚΠΔ / GDPR) και παρατίθενται παρακάτω.
        </p>
        <p><strong>Με την επιφύλαξη ορισμένων περιορισμών, έχετε τα ακόλουθα δικαιώματα σχετικά με τα δεδομένα σας:</strong></p>
        <ul>
            <li>
                <strong>Δικαίωμα ενημέρωσης</strong> — έχετε το δικαίωμα να λάβετε επιβεβαίωση για το αν
                επεξεργαζόμαστε προσωπικά δεδομένα που σας αφορούν και να ζητήσετε αντίγραφο των πληροφοριών που
                διατηρούμε για εσάς.
            </li>
            <li>
                <strong>Δικαίωμα πρόσβασης</strong> — έχετε το δικαίωμα πρόσβασης στα προσωπικά σας δεδομένα που
                διατηρούμε.
            </li>
            <li>
                <strong>Δικαίωμα διόρθωσης</strong> — έχετε το δικαίωμα να ζητήσετε τη διόρθωση ανακριβών
                προσωπικών δεδομένων ή τη συμπλήρωσή τους, αν είναι ελλιπή.
            </li>
            <li>
                <strong>Δικαίωμα διαγραφής («δικαίωμα στη λήθη»)</strong> — υπό ορισμένες προϋποθέσεις, έχετε το
                δικαίωμα να ζητήσετε τη διαγραφή των προσωπικών σας δεδομένων. Αυτό ισχύει, για παράδειγμα, όταν τα
                δεδομένα δεν είναι πλέον απαραίτητα για τους σκοπούς για τους οποίους συλλέχθηκαν ή υποβλήθηκαν σε
                επεξεργασία, ή όταν ανακαλείτε τη συγκατάθεση στην οποία βασίζεται η επεξεργασία και δεν υπάρχει
                άλλη νόμιμη βάση για τη συνέχισή της.
            </li>
            <li>
                <strong>Δικαίωμα περιορισμού της επεξεργασίας</strong> — έχετε το δικαίωμα να ζητήσετε τον
                περιορισμό της επεξεργασίας των προσωπικών σας δεδομένων. Αυτό ισχύει, για παράδειγμα, όταν
                αμφισβητείτε την ακρίβεια των δεδομένων ή όταν η επεξεργασία είναι παράνομη και αντιτίθεστε στη
                διαγραφή τους, ζητώντας αντί αυτής τον περιορισμό της χρήσης τους.
            </li>
            <li>
                <strong>Δικαίωμα στη φορητότητα των δεδομένων</strong> — έχετε το δικαίωμα να μας ζητήσετε να
                διαβιβάσουμε ορισμένα από τα προσωπικά δεδομένα που διατηρούμε για εσάς σε άλλον οργανισμό και να
                τα επαναχρησιμοποιήσετε για δικούς σας σκοπούς σε διαφορετικές υπηρεσίες. Το δικαίωμα αυτό αφορά
                τα προσωπικά δεδομένα που μας έχετε παράσχει, σε δομημένο, κοινώς χρησιμοποιούμενο και
                μηχαναγνώσιμο μορφότυπο, εφόσον:
                <ul>
                    <li>η επεξεργασία βασίζεται σε συγκατάθεση ή σε σύμβαση, και</li>
                    <li>η επεξεργασία διενεργείται με αυτοματοποιημένα μέσα.</li>
                </ul>
                Ασκώντας το δικαίωμα αυτό, έχετε το δικαίωμα να ζητήσετε τη διαβίβαση των δεδομένων απευθείας
                από το B.I.G. σε άλλον υπεύθυνο επεξεργασίας, όπου αυτό είναι τεχνικά εφικτό.
            </li>
            <li>
                <strong>Δικαίωμα εναντίωσης</strong> — έχετε το δικαίωμα να ανακαλέσετε, εν όλω ή εν μέρει, τη
                συγκατάθεση που έχετε δώσει για την επεξεργασία των προσωπικών σας δεδομένων. Η ανάκληση ισχύει από
                τη στιγμή που θα γίνει. Έχετε επίσης το δικαίωμα να αντιταχθείτε στην επεξεργασία των προσωπικών
                σας δεδομένων από εμάς και πάντα το δικαίωμα να αντιταχθείτε σε ενέργειες προώθησης, όπως τα
                ενημερωτικά δελτία (newsletters).
            </li>
            <li>
                <strong>Δικαιώματα σχετικά με την αυτοματοποιημένη λήψη αποφάσεων και την κατάρτιση
                    προφίλ</strong> — έχετε το δικαίωμα να μην υπόκεισθε σε απόφαση που βασίζεται αποκλειστικά σε
                αυτοματοποιημένη επεξεργασία, συμπεριλαμβανομένης της κατάρτισης προφίλ.
            </li>
            <li>
                <strong>Δικαίωμα υποβολής καταγγελίας σε εποπτική αρχή</strong> — αν θεωρείτε ότι τα δικαιώματά
                σας παραβιάζονται με οποιονδήποτε τρόπο, έχετε το δικαίωμα να υποβάλετε καταγγελία σε εποπτική
                αρχή, ιδίως στο κράτος μέλος της ΕΕ/ΕΟΧ της συνήθους διαμονής σας, του τόπου εργασίας σας ή του
                τόπου της εικαζόμενης παραβίασης. Στην Ελλάδα, εποπτική αρχή είναι η Αρχή Προστασίας Δεδομένων
                Προσωπικού Χαρακτήρα. Το δικαίωμα αυτό ισχύει με την επιφύλαξη κάθε άλλης διοικητικής ή δικαστικής
                προσφυγής.
            </li>
            <li>
                <strong>Επιβεβαίωση ταυτότητας:</strong> σε περίπτωση αμφιβολίας μπορούμε να ζητήσουμε πρόσθετες
                πληροφορίες για την επιβεβαίωση της ταυτότητάς σας. Αυτό γίνεται για την προστασία των δικαιωμάτων
                και της ιδιωτικής σας σφαίρας.
            </li>
            <li>
                <strong>Κατάχρηση δικαιωμάτων:</strong> αν ασκείτε κάποιο από τα δικαιώματα αυτά υπερβολικά συχνά
                και με προφανή πρόθεση κατάχρησης, ενδέχεται να χρεώσουμε διοικητικό τέλος ή να αρνηθούμε να
                διεκπεραιώσουμε το αίτημά σας.
            </li>
        </ul>

        <h2>Αλλαγές στην Πολιτική Απορρήτου</h2>
        <p>
            Το B.I.G. διατηρεί το δικαίωμα να τροποποιεί ή να συμπληρώνει την Πολιτική Απορρήτου ανά πάσα
            στιγμή και για οποιονδήποτε λόγο, όπως επιτρέπεται από την ισχύουσα νομοθεσία. Σε περίπτωση
            ουσιωδών αλλαγών, η Πολιτική Απορρήτου θα ενημερώνεται σε αυτή τη σελίδα. Για τον λόγο αυτό σας
            συνιστούμε να ελέγχετε τακτικά το περιεχόμενό της.
        </p>
        <p>Τελευταία ενημέρωση της παρούσας Πολιτικής Απορρήτου: {{ lastUpdated }}.</p>
    </content-page>
</template>

<script>
    import ContentPage from '@/components/ContentPage'
    export default {
        components: { ContentPage },
        data() {
            return {
                // Change this whenever the policy text changes
                lastUpdated: '3 Οκτωβρίου 2026'
            }
        }
    }
</script>
